<template>
  <div>
    <slot/>
  </div>
</template>

<script>
export default {
  //https://github.com/drewjbartlett/vue-flickity
  
  props: {
    options: Object,
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    this.$flickity.destroy();
    this.$flickity = null;
  },

  methods: {

    init() {
      const Flickity = require('flickity');
      this.$flickity = new Flickity(this.$el, this.options);
      this.$emit('init', this.$flickity);
    },
    
    flickity() {
      return this.$flickity;
    },

    select(index, isWrapped, isInstant) {
      this.$flickity.select(index, isWrapped, isInstant);
    },
    
    next(isWrapped, isInstant) {
      this.$flickity.next(isWrapped, isInstant);
    },

    previous(isWrapped, isInstant) {
      this.$flickity.previous(isWrapped, isInstant);
    },

    selectCell(value, isWrapped, isInstant) {
      this.$flickity.selectCell(value, isWrapped, isInstant);
    },

    resize() {
      this.$flickity.resize();
    },

    reposition() {
      this.$flickity.reposition();
    },

    prepend(elements) {
      this.$flickity.prepend(elements);
    },

    append(elements) {
      this.$flickity.append(elements);
    },

    insert(elements, index) {
      this.$flickity.insert(elements, index);
    },

    remove(elements) {
      this.$flickity.remove(elements);
    },

    playPlayer() {
      this.$flickity.playPlayer();
    },

    stopPlayer() {
      this.$flickity.stopPlayer();
    },

    pausePlayer() {
      this.$flickity.pausePlayer();
    },

    unpausePlayer() {
      this.$flickity.unpausePlayer();
    },

    rerender() {
      this.$flickity.destroy();
      this.init();
    },

    destroy() {
      this.$flickity.destroy();
    },

    reloadCells() {
      this.$flickity.reloadCells();
    },

    getCellElements() {
      return this.$flickity.getCellElements();
    },

    data() {
      const Flickity = require('flickity');
      return Flickity.data(this.$el);
    },

    on(eventName, listener) {
      this.$flickity.on(eventName, listener);
    },

    off(eventName, listener) {
      this.$flickity.off(eventName, listener);
    },

    once(eventName, listener) {
      this.$flickity.once(eventName, listener);
    },

    selectedElement() {
      return this.$flickity.selectedElement;
    },

    selectedElements() {
      return this.$flickity.selectedElements;
    },

    selectedIndex() {
      return this.$flickity.selectedIndex;
    },

    cells() {
      return this.$flickity.cells;
    },

    slides() {
      return this.$flickity.slides;
    },

    disableDrag() {
      this.$flickity.options.draggable = false;
      this.$flickity.updateDraggable();
    },

    enableDrag() {
      this.$flickity.options.draggable = true;
      this.$flickity.updateDraggable();
    },
  },
}
</script>
<style src='flickity/dist/flickity.css'></style>